query MobileBusinessUnitsTableData(
	$days: Int!
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$mfaOsFilter: ConditionStringArray
	$mfaAppIdFilter: ConditionStringArray
	$msdkOsFilter: ConditionString
	$msdkAppFilter: ConditionString
) {
	mfaRuns: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		custom_fields
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	msdkRuns: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		custom_fields
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
}
